module.exports = __webpack_public_path__ + "img/index-qysl1.c16d5e6e.png";